import React from 'react';
import { SEVERITY_COLORS } from './_shared';

export default function SentinelsTab({ queue }) {
  const noisy = (queue || []).filter(r => r.kind === 'noisy_alert');
  if (noisy.length === 0) {
    return (
      <div className="text-slate-500 text-sm p-4" data-testid="governance-sentinels">
        No noisy sentinels detected — nice and quiet!
      </div>
    );
  }
  return (
    <div className="space-y-2" data-testid="governance-sentinels">
      {noisy.map(r => (
        <div key={r.rec_id} className="rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900/50 p-4 flex items-center justify-between gap-3">
          <div>
            <div className="font-medium text-slate-800 dark:text-slate-200">{r.object_name}</div>
            <div className="text-xs text-slate-500 mt-0.5">{r.reason}</div>
            {r.ai_explanation && <div className="text-xs text-slate-600 dark:text-slate-400 mt-1 italic">{r.ai_explanation}</div>}
          </div>
          <span className={`text-xs px-2 py-1 rounded border ${SEVERITY_COLORS[r.severity] || SEVERITY_COLORS.info}`}>{(r.severity || '').toUpperCase()}</span>
        </div>
      ))}
    </div>
  );
}
